// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_REMOVE_BUYER = "Odstr\u00e1\u0148 z\u00e1ujemcu";
export const BZ2_REPLY = "Odpovedz";
export const BZ2_REPLY_TO_seller = "Odpovedz predajcovi (%(seller)s)";
export const BZ2_REVIEW_BUYER = "Ohodno\u0165 kupuj\u00facu";
export const BZ2_REVIEW_SELLER = "Ohodno\u0165 pred\u00e1vaj\u00facu";
